import isAvailable from '../../lib/isAvailable'

export default async function extractLatestPublicIssues(wholeissue) {
  if (!isAvailable(wholeissue)) return
  const publicIssues = await wholeissue.filter(
    (issue) => issue.is_private === false
  )
  return publicIssues
}
